import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { hot } from "react-hot-loader/root";
import { ConfigProvider } from "antd";
import {
  HashRouter as Router,
  Route,
  Switch,
  // useLocation,
} from "react-router-dom";
import { Platform, Auth, PaymentResult } from "./components";
import "./index.less";
import { useStores } from "./store";
import { Restaurant } from "./pages";
import matomo from "./service/matomo";

function Root() {
  const { memberStore } = useStores();
  const locale = memberStore.getLocale();
  // const location = useLocation();
  // useEffect(() => {
  //   window.gtag("event", "page_view", {
  //     path_path: location.pathname + location.search + location.hash,
  //     path_search: location.search,
  //     path_hash: location.hash,
  //   });
  // }, [location]);
  return (
    <ConfigProvider locale={locale}>
      <div className="page-main">
        <main>
          <Switch>
            <Route path="/restaurants/:id" component={Restaurant}></Route>
            <Route
              path="/paymentResult/:paymentStr"
              component={PaymentResult}
            ></Route>
          </Switch>
        </main>
        <Platform></Platform>
      </div>
    </ConfigProvider>
  );
}

function App() {
  return (
    <Auth>
      <Router>
        <Root></Root>
      </Router>
    </Auth>
  );
}

async function bootstrap() {
  const WithHotReload = process.env.NODE_ENV === "production" ? App : hot(App);
  ReactDOM.render(<WithHotReload />, document.getElementById("root"));
  window.addEventListener('message', evt => {
    if (evt.data.type === 'navigate') {
      location.replace(evt.data.url)
    }
  })
}
matomo();
bootstrap();
